import { isMagnoliaEditingMode } from '../../../helper';

export interface StickyToolbarItemNotification {
  id: string;
  duration: number;
  idleDuration: number;
  headline: string;
  leadtext?: string;
}

interface StickyToolbarNotificationCookieItem {
  id: string;
  notificationCount: number;
}

export const getSessionStorageAsArray = (): StickyToolbarNotificationCookieItem[] =>
  Array.from(JSON.parse(sessionStorage.getItem('sticky-toolbar-notification')) || {});

export const getExistingItemFromSessionStorage = (identifier: string): StickyToolbarNotificationCookieItem[] =>
  getSessionStorageAsArray().filter((item) => item.id === identifier);

export const setSessionStorageCookie = (identifier: string) => {
  const matchingCookieItem = getExistingItemFromSessionStorage(identifier);
  if (matchingCookieItem[0]?.notificationCount < 2) {
    const currentStorage = getSessionStorageAsArray();
    currentStorage.filter((item) => item.id === identifier)[0].notificationCount += 1;
    sessionStorage.setItem('sticky-toolbar-notification', JSON.stringify(currentStorage));
  } else {
    const newCookie = [
      ...getSessionStorageAsArray(),
      {
        id: identifier,
        notificationCount: 1,
      },
    ];
    sessionStorage.setItem('sticky-toolbar-notification', JSON.stringify(newCookie));
  }
};

export const handleItemNotification = (
  element: HTMLElement,
  notification: StickyToolbarItemNotification,
  isMobile?: boolean
) => {
  if (isMagnoliaEditingMode()) {
    return;
  }

  const matchingCookieItem = getExistingItemFromSessionStorage(notification.id);
  if (matchingCookieItem[0]?.notificationCount === 2) {
    return;
  }

  if (isMobile || !matchingCookieItem[0] || matchingCookieItem[0]?.notificationCount <= 2) {
    const evenDuration = notification.duration % 2 === 0 ? notification.duration : notification.duration + 1;

    const startNotificationEvent = new CustomEvent('notificationStart', {
      bubbles: true,
    });
    const stopNotificationEvent = new CustomEvent('notificationStop', {
      bubbles: true,
    });
    setTimeout(() => {
      element.dispatchEvent(startNotificationEvent);
      setTimeout(() => {
        element.dispatchEvent(stopNotificationEvent);
      }, evenDuration * 1000);
    }, notification.idleDuration * 1000);
    setSessionStorageCookie(notification.id);
  }
};
